export const services = Object.freeze({
  NODE_ENDPOINT_UPLOAD_ICON: "assets/uploadIcon",
  NODE_ENDPOINT_GET_ALL_ICONS: "assets/get-all-icons",
  NODE_ENDPOINT_DELETE_ICON: "assets/deleteIcon",
  NODE_ENDPOINT_RENAME_ICON: "assets/renameIcon",
});
